import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, CrossIcon } from './Icons';
export function ComparisonTable() {
  const comparisons = [{
    pro: 'Elaboración artesanal propia, sin intermediarios',
    con: 'Productos comprados ya listos para revender'
  }, {
    pro: 'Producción el mismo día del evento',
    con: 'Preparación con días de anticipación'
  }, {
    pro: 'Presentación visual trabajada y fotografiable',
    con: 'Bandejas genéricas sin identidad'
  }, {
    pro: 'Adaptación a su evento específico',
    con: 'Menús rígidos que no se pueden personalizar'
  }, {
    pro: 'Puntualidad y comunicación directa',
    con: 'Sorpresas de último momento'
  }, {
    pro: 'Atención personalizada desde el primer contacto',
    con: 'Call centers y formularios sin respuesta'
  }];
  return <section id="servicios" className="py-24 bg-cream" data-id="element-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <FadeIn className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-serif text-deep-brown mb-6" data-id="element-19">
            ¿Qué hace diferente a nuestro catering?
          </h2>
          <p className="text-lg text-brown-medium max-w-2xl mx-auto" data-id="element-20">
            Presentamos: Delisandwiches — Catering Artesanal de Elaboración
            Propia en Carrasco, Montevideo. No somos una cadena. No trabajamos
            con productos industriales.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-21">
          <div className="bg-warm-white rounded-sm shadow-sm border border-sand overflow-hidden" data-id="element-22">
            {/* Desktop Header */}
            <div className="hidden md:grid grid-cols-2 bg-linen border-b border-sand" data-id="element-23">
              <div className="p-6 text-center border-r border-sand" data-id="element-24">
                <h3 className="text-xl font-serif text-olive flex items-center justify-center gap-2" data-id="element-25">
                  <CheckIcon className="w-6 h-6" data-id="element-26" />
                  Lo que ofrecemos
                </h3>
              </div>
              <div className="p-6 text-center" data-id="element-27">
                <h3 className="text-xl font-serif text-terracotta flex items-center justify-center gap-2" data-id="element-28">
                  <CrossIcon className="w-6 h-6" data-id="element-29" />
                  Lo que evitamos
                </h3>
              </div>
            </div>

            {/* Rows */}
            <div className="divide-y divide-sand" data-id="element-30">
              {comparisons.map((item, index) => <div key={index} className="grid md:grid-cols-2" data-id="element-31">
                  {/* Pro side */}
                  <div className="p-6 md:border-r border-sand bg-olive/5 flex items-start gap-4" data-id="element-32">
                    <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" data-id="element-33" />
                    <p className="text-deep-brown font-medium" data-id="element-34">{item.pro}</p>
                  </div>

                  {/* Con side */}
                  <div className="p-6 bg-terracotta/5 flex items-start gap-4 border-b md:border-b-0 border-sand last:border-b-0" data-id="element-35">
                    <CrossIcon className="w-5 h-5 mt-0.5 flex-shrink-0 opacity-70" data-id="element-36" />
                    <p className="text-brown-medium" data-id="element-37">{item.con}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}